module.exports = __webpack_public_path__ + "static/media/oxygen mall render 02.0849b45a.webp";